import addDomain from './addDomain'
import manageDomain from './manageDomain'

export default {
  addDomain,
  manageDomain
}
